<script lang="ts" setup>
defineProps<{
  text: string;
  image: string;
}>();
</script>

<template>
  <div class="border-primary relative h-[305px] w-[305px] overflow-hidden rounded-2xl border-2">
    <!-- Image -->
    <img :src="image" alt="image" class="h-full w-full object-cover" loading="lazy" />

    <!-- Overlay gradient -->
    <div class="absolute inset-0 bg-[linear-gradient(180deg,rgba(16,16,16,0)_0%,#101010_100%)]"></div>

    <!-- Text -->
    <div class="text-text-white absolute bottom-0 left-0 z-10 px-6 pb-6 text-xl leading-[120%]">
      {{ text }}
    </div>
  </div>
</template>
